import { Input, TextArea } from "@light-technology/components";
import { Type01 } from "@untitledui/icons";
import { type ChangeEvent } from "react";
import { useController, type Control } from "react-hook-form";
import { useFormatPlanName } from "../../utilities/useFormatPlanName";
import type { FormValues } from "./common";

type EditNameDescriptionProps = {
  control: Control<FormValues>;
};

export const EditNameDescription = ({ control }: EditNameDescriptionProps) => {
  const formatPlanName = useFormatPlanName();
  const { field: nameField } = useController({
    control,
    name: "name",
    rules: {
      required: true,
    },
  });
  const { field: descriptionField } = useController({
    control,
    name: "description",
  });
  return (
    <div className="flex flex-col gap-2xl">
      <div className="flex w-full flex-row items-center gap-md">
        <Type01 />
        <div className="w-full text-lg font-semibold">Name and description</div>
      </div>
      <div className="flex flex-col gap-sm">
        <Input label="Plan name" isRequired {...nameField} />
        <div className="flex flex-col gap-sm rounded-xl bg-tertiary p-xl">
          <div className="text-sm text-secondary">Customer previews</div>
          <div className="text-sm text-secondary">
            "Thanks for signing up for the{" "}
            {formatPlanName(nameField.value || "[plan name]")}."
          </div>
        </div>
      </div>
      <TextArea
        label="Internal description"
        hint="Only visible to your team and not customers"
        {...descriptionField}
        onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
          descriptionField.onChange(event.target.value);
        }}
        value={descriptionField.value?.toString()}
        isRequired
      />
    </div>
  );
};
